import React from 'react';
import { Section, SectionHeader } from './ui/Section';
import { Button } from './ui/Button';
import { Reveal } from './ui/Reveal';
import { Mail, Linkedin, ShieldCheck, User } from 'lucide-react';
export function ContactSection() {
  return <Section id="contact" variant="charcoal" data-id="element-84">
      <SectionHeader title="Let's Connect" subtitle="Open to Opportunities" data-id="element-85" />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-86">
        <Reveal data-id="element-87">
          <div className="space-y-8" data-id="element-88">
            <p className="text-lg text-slate-300 leading-relaxed" data-id="element-89">
              Actively seeking executive roles, board appointments, and
              strategic advisory engagements in defense, aerospace, and federal
              contracting. All inquiries handled with strict confidentiality.
            </p>

            <div className="space-y-4" data-id="element-90">
              <div className="flex items-center gap-4" data-id="element-91">
                <div className="w-10 h-10 bg-navy-900 border border-gold-500 flex items-center justify-center" data-id="element-92">
                  <Mail className="text-gold-500 w-5 h-5" data-id="element-93" />
                </div>
                <div data-id="element-94">
                  <h4 className="text-xs font-heading uppercase tracking-widest text-slate-500" data-id="element-95">
                    Email
                  </h4>
                  <a href="mailto:guy.beougher@gmail.com" className="text-white hover:text-gold-500 transition-colors" data-id="element-96">
                    guy.beougher@gmail.com
                  </a>
                </div>
              </div>

              <div className="flex items-center gap-4" data-id="element-97">
                <div className="w-10 h-10 bg-navy-900 border border-gold-500 flex items-center justify-center" data-id="element-98">
                  <Linkedin className="text-gold-500 w-5 h-5" data-id="element-99" />
                </div>
                <div data-id="element-100">
                  <h4 className="text-xs font-heading uppercase tracking-widest text-slate-500" data-id="element-101">
                    LinkedIn
                  </h4>
                  <a href="https://linkedin.com/in/guybeougher" target="_blank" rel="noopener noreferrer" className="text-white hover:text-gold-500 transition-colors" data-id="element-102">
                    linkedin.com/in/guybeougher
                  </a>
                </div>
              </div>

              <div className="flex items-center gap-4" data-id="element-103">
                <div className="w-10 h-10 bg-navy-900 border border-gold-500 flex items-center justify-center" data-id="element-104">
                  <ShieldCheck className="text-gold-500 w-5 h-5" data-id="element-105" />
                </div>
                <div data-id="element-106">
                  <h4 className="text-xs font-heading uppercase tracking-widest text-slate-500" data-id="element-107">
                    Clearance Status
                  </h4>
                  <span className="text-white" data-id="element-108">Active Top Secret / SCI</span>
                </div>
              </div>
            </div>

            {/* Headshot */}
            <div className="mt-8 border border-gold-500/30 bg-navy-900 p-3 max-w-xs shadow-[0_0_20px_rgba(197,165,90,0.1)]" data-id="element-109">
              <img src="https://cdn.magicpatterns.com/uploads/qHTWKxA3Q89G5ZvNigM12i/1698369576334.jpg" alt="Guy C. Beougher" className="w-full object-cover object-top aspect-[3/4]" data-id="element-110" />
              <p className="text-center text-xs font-heading uppercase tracking-widest text-gold-500 mt-3 pb-1" data-id="element-111">
                Guy C. Beougher
              </p>
            </div>
          </div>
        </Reveal>

        <Reveal delay={200} data-id="element-112">
          <div className="bg-navy-900 p-8 border border-white/5 h-full" data-id="element-113">
            <h3 className="text-xl font-bold text-white uppercase mb-6" data-id="element-114">
              Inquiry Form
            </h3>
            <form className="space-y-4" data-id="element-115">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-116">
                <div className="space-y-1" data-id="element-117">
                  <label className="text-xs font-heading uppercase tracking-widest text-gold-500" data-id="element-118">
                    Name
                  </label>
                  <input type="text" className="w-full bg-navy-800 border border-navy-600 p-3 text-white focus:border-gold-500 focus:outline-none transition-colors" data-id="element-119" />
                </div>
                <div className="space-y-1" data-id="element-120">
                  <label className="text-xs font-heading uppercase tracking-widest text-gold-500" data-id="element-121">
                    Organization
                  </label>
                  <input type="text" className="w-full bg-navy-800 border border-navy-600 p-3 text-white focus:border-gold-500 focus:outline-none transition-colors" data-id="element-122" />
                </div>
              </div>
              <div className="space-y-1" data-id="element-123">
                <label className="text-xs font-heading uppercase tracking-widest text-gold-500" data-id="element-124">
                  Email
                </label>
                <input type="email" className="w-full bg-navy-800 border border-navy-600 p-3 text-white focus:border-gold-500 focus:outline-none transition-colors" data-id="element-125" />
              </div>
              <div className="space-y-1" data-id="element-126">
                <label className="text-xs font-heading uppercase tracking-widest text-gold-500" data-id="element-127">
                  Opportunity / Message
                </label>
                <textarea rows={4} className="w-full bg-navy-800 border border-navy-600 p-3 text-white focus:border-gold-500 focus:outline-none transition-colors" data-id="element-128"></textarea>
              </div>
              <Button className="w-full" data-id="element-129">Send Message</Button>
            </form>
          </div>
        </Reveal>
      </div>
    </Section>;
}